// extracted by mini-css-extract-plugin
export default {"historical":"kgyBQquLbBFN44aHNCJP"};